// Copyright (c) 2016 Deere & Company

import './actions-popover.scss';
import React, {PropTypes} from 'react';
import ActionsPopoverList from './actions-popover-list';
import {FormattedMessage} from 'react-intl';
import Popover from '../../../shared/components/popover/popover';

const ActionsPopover = props => {

    const getIconClassName = icon => {

        const map = {
            PDF: 'button-icon-pdf'
        };

        return map[icon];

    };

    const popoverTarget = (
        <div>
            {props.showCaret ?
                <span className='actions-popover-caret'/> :
                <button className='actions-popover-button'>
                    {props.showButtonIcon &&
                    <span className={getIconClassName(props.icon)}/>
                    }
                    <FormattedMessage id={props.label}/>
                </button>
            }
        </div>
    );

    const popoverContent = (
        <ActionsPopoverList
            options={props.options}
        />
    );

    return (
        <Popover
            additionalClass={props.showCaret ? 'caret' : ''}
            content={popoverContent}
            target={popoverTarget}
        />
    );

};

ActionsPopover.displayName = 'ActionsPopover';
ActionsPopover.propTypes = {
    icon: PropTypes.string.isRequired,
    label: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.object).isRequired,
    showButtonIcon: PropTypes.bool.isRequired,
    showCaret: PropTypes.bool
};
ActionsPopover.defaultProps = {
    icon: 'NONE',
    label: 'ACTIONS',
    showButtonIcon: false,
    showCaret: false
};

export default ActionsPopover;



// WEBPACK FOOTER //
// ./src/shared/components/actions-popover/index.js